var model = BD.Model.extend({
    conversionBalance: BD.belongsTo('Billy.ConversionBalance', { isParent: true }),
    account: BD.belongsTo('Billy.Account'),
    amount: BD.attr('number')
})

module.exports = model
